import React from "react";
import moment from "moment";
import { RaisedButton } from "material-ui";

import Chart from "./partials/charts/chart.jsx";
import * as util from "../util";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";
import PassBucketStore from "../stores/PassBucketStore";
import PassBucketActions from "../actions/PassBucketActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import StatsBlockContainer from "./partials/stats-block-container.jsx";
import StatsBlock from "./partials/stats-block.jsx";

import PassSalesAnalyticsTable from "./partials/pass-sales-analytics-table.jsx";
import GenericAnalyticsTable from "./partials/generic-analytics-table.jsx";
import AnalyticsFilterWidget from "./partials/analytics-filter-widget.jsx";

import FromCacheCallout from "./partials/from-cache-callout.jsx";

class PassAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allTime: false,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      showCharts: false,
      filterState: "passes",
      isMembership: null,
      widgetReset: false,
    };

    this.onWindowClick = this.onWindowClick.bind(this);
    this.onWindowKeyDown = this.onWindowKeyDown.bind(this);
    this.handleSegmentFilterChange = this.handleSegmentFilterChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.setPage = this.setPage.bind(this);
  }

  static getStores() {
    return [EventBucketStore, PassBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getPassBucketsOverview: AnalyticsStore.getPassBucketsOverview,
      getPassSalesAnalytics: AnalyticsStore.getPassSalesAnalytics,
      getPassBucketsForEventBucket: PassBucketStore.getPassBucketsForEventBucket,
      getMembershipsForEventBucket: PassBucketStore.getMembershipsForEventBucket,
      getPassBucketsAndMembershipsForEventBucket: PassBucketStore.getPassBucketsAndMembershipsForEventBucket,
      getPassBucketById: PassBucketStore.getPassBucketById,
      passBuckets: PassBucketStore.getState().passBuckets,
      isFetchingPassSalesAnalytics: AnalyticsStore.getState().isFetchingPassSalesAnalytics,
      isFetchingPassBucketsOverview: AnalyticsStore.getState().isFetchingPassBucketsOverview,
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  onWindowClick(e) {
    if (
      this.state.showRangeEditor &&
      (!this.container ||
        (!this.container.contains(e.target) &&
          !this.rangeButton.contains(e.target)))
    ) {
      this.setState({ showRangeEditor: false });
    }
  }

  onWindowKeyDown(e) {
    if (this.state.showRangeEditor && e.which === 27) {
      // esc
      this.setState({ showRangeEditor: false });
    }
  }

  // Set the state of the page to reflect if we are on a 
  // pass page or a membership page.
  async setPage() {
    if (this.props.location.pathname.includes("memberships")) {
      await this.setState({ isMembership: true, filterState: "memberships" })
      this.componentWillReceiveProps(this.props, true);
    } else {
      await this.setState({ isMembership: false, filterState: "passes" })
      this.componentWillReceiveProps(this.props, true);
    }
  }

  componentDidMount() {
    this.setPage(); // set state to reflect pass vs. membership
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setPage();  // set state to reflect pass vs. membership
    }
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      AnalyticsActions.fetchPassBucketsOverview.defer({
        eventBucketId: newProps.params.eventBucketId,
        filterState: this.state.filterState,
        startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
        endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
        allTime: this.state.allTime
      });
      AnalyticsActions.fetchPassSalesAnalytics.defer({
        eventBucketId: newProps.params.eventBucketId,
        isMembership: this.state.isMembership,
        filterState: this.state.filterState,
        startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
        endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
        allTime: this.state.allTime
      });
      PassBucketActions.fetchAllForEventBucket.defer(
        newProps.params.eventBucketId,
      );
    }
  }

  handleSegmentFilterChange(props) {
    this.setState({ filterState: props },
      () => this.componentWillReceiveProps(this.props, true)
    )
  }

  handleDateChange({ range, allTime }) {
    this.setState({ range: range, allTime: allTime },
      () => this.componentWillReceiveProps(this.props, true)
    );
  }

  render() {
    const {
      params: { eventBucketId },
      getPassBucketById
    } = this.props;
    const eventBucket = this.props.getEventBucketById(eventBucketId);
    const defaultItemsPerPage = 25;

    const passBuckets =
      this.state.filterState !== "all"
        ? this.state.filterState === "passes"
          ? this.props.getPassBucketsForEventBucket(eventBucketId)
          : this.props.getMembershipsForEventBucket(eventBucketId)
        : this.props.getPassBucketsAndMembershipsForEventBucket(eventBucketId)

    const analyticsOverview = this.props.getPassBucketsOverview(eventBucketId);
    const salesAnalytics = this.props.getPassSalesAnalytics(eventBucketId);

    const isMembership = this.props.location.pathname.includes("memberships")

    if (
      !analyticsOverview
      || !salesAnalytics
      || !passBuckets
      || !eventBucket
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    let { totals } = analyticsOverview;

    const passTotal = Object.values(totals).reduce((c, i) => c + i.count, 0);
    const freeTotal = Object.values(totals).reduce((c, i) => c + i.free_count, 0);
    const paidTotal = passTotal - freeTotal;

    let rows = (salesAnalytics.sales || []).map(function (next) {
      const date = new Date(next.date.year, next.date.month - 1, next.date.day);
      return [
        {
          timeframe: { end: date },
          value: next.pass_buckets.map(b => ({
            pass_bucket: (
              getPassBucketById(b.pass_bucket) || {
                name: isMembership ? "Deleted membership" : "Deleted pass bucket"
              }
            ).name,
            result: b.count
          }))
        },
        {
          timeframe: { end: date },
          value: next.pass_buckets.map(b => ({
            pass_bucket: (
              getPassBucketById(b.pass_bucket) || {
                name: isMembership ? "Deleted membership" : "Deleted pass bucket"
              }
            ).name,
            result: b.amount / 100
          }))
        }
      ];
    });

    let filledRows = util.fillMissingDaysNew(
      rows.map(r => r[0]),
      "timeframe.end",
      { default: 0 }
    );
    filledRows = filledRows.map(r => {
      r.timeframe.end = r.timeframe.end.toISOString();
      return r;
    });

    let filledSalesRows = util.fillMissingDaysNew(
      rows.map(r => r[1]),
      "timeframe.end",
      { default: 0 }
    );
    filledSalesRows = filledSalesRows.map(r => {
      r.timeframe.end = r.timeframe.end.toISOString();
      return r;
    });

    const chartOptions = {
      point: { show: false }
    };

    const membershipsEnabledforEventBucket = this.props.getEventBucketById(eventBucketId).frontend_config.memberships_enabled
    const browserTimezone = moment.tz(moment.tz.guess()).format('z');

    return (
      <div>
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label={isMembership ? "membership sales analytics" : "pass sales analytics"}
          subpath="passes"
        />
        <AnalyticsFilterWidget
          // re-render this component when we switch from passes to memberships
          // and vice-versa:
          key={isMembership ? "membership" : "passes"}
          showDateFilter={true}
          onDateRangeChange={this.handleDateChange}
          showSegmentFilter={!isMembership && membershipsEnabledforEventBucket ? true : false}
          segmentFilterSelected={this.state.filterState}
          onSegmentFilterChange={this.handleSegmentFilterChange}
          segmentFilterTitle={"Filter by"}
          segmentFilterConfig={[
            {
              value: "passes",
              label: "Non-Membership Passes"
            },
            {
              value: "all",
              label: "All Passes"
            }
          ]}
        />
        <FromCacheCallout analytics={salesAnalytics} />
        {
          !analyticsOverview
            || !salesAnalytics
            || !passBuckets
            || !eventBucket
            || this.props.isFetchingPassSalesAnalytics
            || this.props.isFetchingPassBucketsOverview
            ? (
              <div><WorkingIndicator fullPage={true} /></div>
            ) : (
              <div>
                <p>
                  Scroll down to view <a href="#total-sales">total sales</a>,{" "}
                  <a href="#free-vs-paid">free vs paid</a>,{" "}
                  <a href="#ticket-orders">ticket order breakdown</a>,{" "}
                  <a href="#passes-chart">{isMembership ? "memberships" : "passes"} issued by day</a>, and{" "}
                  <a href="#sales-chart">sales by day</a>.
                </p>
                <StatsBlockContainer style={{ marginTop: -10 }}>
                  <StatsBlock
                    value={util.formatNumber(passTotal)}
                    label={`Total ${isMembership ? "memberships" : "passes"} issued`}
                  />
                  <StatsBlock
                    value={util.formatPrice(salesAnalytics.total_volume)}
                    label={`Total ${isMembership ? "membership" : "pass"} sales volume`}
                  />
                </StatsBlockContainer>

                <a className="anchor--fixed_header_offset" id="total-sales" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em" }}>Total sales data</h2>
                  <PassSalesAnalyticsTable
                    eventBucket={eventBucket}
                    data={salesAnalytics.volumes}
                    passBuckets={this.props.passBuckets}
                    isMembership={isMembership}
                    itemsPerPage={defaultItemsPerPage}
                  />
                </div>
                <a className="anchor--fixed_header_offset" id="free-vs-paid" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em" }}>Free vs paid breakdown</h2>
                  <h3>
                    {passTotal} total {isMembership ? "memberships" : "passes"} issued ({freeTotal} free, {paidTotal} paid)
                  </h3>
                  <GenericAnalyticsTable
                    eventBucket={eventBucket}
                    label={isMembership ? "Membership Bucket" : "Pass bucket"}
                    csvLabel={isMembership ? "membership-free-vs-paid-analytics" : "pass-free-vs-paid-analytics"}
                    source={this.props.passBuckets}
                    itemsPerPage={defaultItemsPerPage}
                    columns={[
                      { label: isMembership ? "Free memberships issued" : "Free passes issued", value: "freeTotal" },
                      { label: isMembership ? "Paid memberships issued" : "Paid passes issued", value: "paidTotal" },
                      { label: "Total", value: "total" }
                    ]}
                    defaultSort="Total"
                    data={passBuckets.map(b => {
                      let total = totals[b.id] ? totals[b.id].count : 0,
                        freeTotal = totals[b.id] ? totals[b.id].free_count : 0,
                        paidTotal = total - freeTotal;

                      return {
                        id: b.id,
                        total,
                        freeTotal,
                        paidTotal
                      };
                    })}
                  />
                </div>
                <a className="anchor--fixed_header_offset" id="ticket-orders" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em" }}>Ticket order breakdown</h2>
                  <h3>
                    {Object.values(totals).reduce((c, i) => c + i.uses, 0)} total tickets
                    issued to passes
                  </h3>
                  <GenericAnalyticsTable
                    eventBucket={eventBucket}
                    label={isMembership ? "Membership Bucket" : "Pass bucket"}
                    csvLabel={isMembership ? "membership-ticket-orders-analytics" : "pass-ticket-orders-analytics"}
                    source={this.props.passBuckets}
                    itemsPerPage={defaultItemsPerPage}
                    columns={[
                      { label: "Total tickets ordered", value: "total" },
                      { label: isMembership ? "Average orders per membership" : "Average orders per pass", value: "average" }
                    ]}
                    defaultSort="Total tickets ordered"
                    data={passBuckets.map(b => {
                      let total = totals[b.id] ? totals[b.id].uses : 0
                      let rawAverage = totals[b.id] ? (totals[b.id].uses / totals[b.id].count) : 1;
                      let average = rawAverage ? rawAverage.toFixed(1) : 0;

                      return {
                        id: b.id,
                        total,
                        average
                      };
                    })}
                  />
                </div>
                <a className="anchor--fixed_header_offset" id="passes-chart" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em" }}>{isMembership ? `Memberships issued, by day, ${browserTimezone}` : `Passes issued, by day, ${browserTimezone}`}</h2>
                  {filledRows.length ? (
                    this.state.showCharts === eventBucketId ? (
                      <Chart
                        type="area"
                        indexBy="timeframe.end"
                        dateFormat="%b %e"
                        height={200}
                        chartOptions={chartOptions}
                        data={filledRows.length && { result: filledRows }}
                      />
                    ) : (
                      <RaisedButton
                        label="Reveal charts"
                        onTouchTap={() => this.setState({ showCharts: eventBucketId })}
                        labelStyle={{ color: "rgb(2, 136, 209)" }}
                      />
                    )
                  ) : (
                    <Chart
                      height={200}
                      placeholder={`Issuance data will be available as soon as the first ${eventBucket.name} pass is issued!`}
                    />
                  )}
                </div>
                <div>
                  <a className="anchor--fixed_header_offset" id="sales-chart" />
                  <div className="analytics-element">
                    <h2 style={{ marginTop: "1em" }}>Sales volume, by day, {browserTimezone}</h2>
                    {filledSalesRows.length ? (
                      this.state.showCharts === eventBucketId ? (
                        <Chart
                          type="area"
                          indexBy="timeframe.end"
                          dateFormat="%b %e"
                          height={200}
                          chartOptions={Object.assign({}, chartOptions, {
                            axis: {
                              y: { tick: { format: p => util.formatPrice(p * 100) } }
                            }
                          })}
                          data={filledSalesRows.length && { result: filledSalesRows }}
                        />
                      ) : (
                        <RaisedButton
                          label="Reveal charts"
                          onTouchTap={() => this.setState({ showCharts: eventBucketId })}
                          labelStyle={{ color: "rgb(2, 136, 209)" }}
                        />
                      )
                    ) : (
                      <Chart
                        height={200}
                        placeholder={`Sales data will be available as soon as the first ${eventBucket.name} pass is sold!`}
                      />
                    )}
                  </div>
                </div>
              </div>)}
      </div>
    );
  }
}

export default connectToStores(PassAnalytics);



// WEBPACK FOOTER //
// ./src/app/components/pass-analytics.jsx